import { Routes } from '@angular/router';
import { AuthGuard } from 'src/auth/auth.guard';
export const ROUTES: Routes = [{
	path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard]
}, {
	path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule), canActivate: [AuthGuard]
}];
